import { getImageData } from 'gatsby-plugin-image';

// eslint-disable-next-line
function urlBuilder({ baseUrl, width, height, format, fit, options }) {
  const url = baseUrl.substring(
    baseUrl.indexOf('/wp-content/') + '/wp-content/'.length
  );

  let fullUrl = `${process.env.GATSBY_CLOUDFLARE_IMAGE_URL}${url}?w=${width}`;

  if (options?.q) {
    fullUrl = `${fullUrl}&q=${options.q}`;
  }

  if (options?.fit) {
    fullUrl = `${fullUrl}&fit=${options.fit}`;
  }
  return fullUrl;
}

export function getCloudFlareImageData({ image, ...props }) {
  return getImageData({
    baseUrl: image.url,
    sourceWidth: image.width,
    sourceHeight: image.height,
    urlBuilder,
    pluginName: 'gatsby-source-example',
    // If your host supports auto-format/content negotiation, pass this as the formats array
    formats: ['auto'],
    ...props,
  });
}
